import React, { Fragment } from 'react';
import { SpinnerDotted } from '.';

const Spinner = ({ children, visible = false , classes = '' }) => {
  return (
    <Fragment>
      {visible && (
        <div className={`fixed top-0 right-0 left-0 bottom-0 z-20 overflow-auto h-full w-full bg-opacity-50 bg-gray-100 ${classes}`}>
          <div className='flex items-center justify-center h-full'>
            <SpinnerDotted />
          </div>
        </div>
      )}
      {children}
    </Fragment>
  );
};

export default Spinner;
